/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-08-25 10:00:55 */

const Keys = {
  submit: 'submit',
  busStops: 'busStops',
  onlySelfArrivalPossible: 'onlySelfArrivalPossible',
  busStopsTooltip: 'busStopsTooltip',
  smallGroupInfo: 'smallGroupInfo',
  smallGroupLabel: 'smallGroupLabel',
  smallGroup: 'smallGroup',
  miniGroupInfo: 'miniGroupInfo',
  miniGroupLabel: 'miniGroupLabel',
  miniGroup: 'miniGroup',
  ownArrivalsAndDepartures: 'ownArrivalsAndDepartures',
  date: 'date',
  pricePerPerson: 'pricePerPerson',
  origin: 'origin',
  busStop: 'busStop',
  busStop_plural: 'busStop_plural',
  possibleBusStops: 'possibleBusStops',
  availability: 'availability',
  night: 'night',
  night_plural: 'night_plural',
  from: 'from',
  instead: 'instead',
  headline: 'headline',
  sectionText: 'sectionText',
  promotionCodeHeadline: 'promotionCodeHeadline',
  promotionCode: 'promotionCode',
  promotionCodeText: 'promotionCodeText',
  promotionCodeSuccess: 'promotionCodeSuccess',
  promotionError: 'promotionError',
  promotionErrorAdditional: 'promotionErrorAdditional',
  promotionErrorOldIsBetter: 'promotionErrorOldIsBetter',
  promotionErrorNewIsOld: 'promotionErrorNewIsOld',
  maintenanceMode: 'maintenanceMode',
  noPackagesFound: 'noPackagesFound',
  provideSearchCriteria: 'provideSearchCriteria',
  addHere: 'addHere',
  promotionCodeEntry: 'promotionCodeEntry'
}; export default Keys;